module.exports = __webpack_public_path__ + "static/img/wx.c0f97b21.png";